import { InfoCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { Popover } from 'antd';
import React from 'react';

interface InfoIconProps {
  iconFontSize?: string;
}
export interface InfoPopoverProps extends InfoIconProps {
  content: React.ReactNode;
  size: 'sm' | 'l';
}
const DefaultInfoCircleOutlined = styled(InfoCircleOutlined)<InfoIconProps>`
  font-size: ${({ iconFontSize }: InfoIconProps) => iconFontSize || '14px'};
`;
const InfoPopover: React.FC<InfoPopoverProps> = ({
  size,
  content,
  iconFontSize,
}: InfoPopoverProps) => (
  <Popover
    placement="topLeft"
    arrowPointAtCenter
    overlayClassName={`popover-${size}`}
    content={content}
  >
    <DefaultInfoCircleOutlined
      iconFontSize={iconFontSize}
      className="m-l-sm"
      data-testid="infoIcon"
    />
  </Popover>
);
export default InfoPopover;
